import styled from 'styled-components'

const MyTimeSheetSc = styled.div`


  padding: 10px;
  width: 65vw;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ddd;

    text-align: left;
    width: 65vw;
  }

  th {
    background-color: #f4f4f4;
    color: #333;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  tr:hover {
    background-color: #f1f1f1;
  }
  .form_container {
    width: 90vw;
    background-color: #f0f0f0;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap:3rem
  }
  .timesheet-entry {
  cursor: pointer;
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  border-radius: 5px;
  background-color: #f9f9f9;
  transition: background-color 0.3s;
  display: flex;
  justify-content: space-between;
}

.timesheet-entry:hover {
  background-color: #e9e9e9;
}

.entry-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  align-items: center;
}

.entry-label {
  font-weight: bold;
  min-width: 100px;
  margin-right: 10px;
}

.entry-content {
  font-size: 14px;
  color: #333;
}

`

export default MyTimeSheetSc
